import { refs } from './refs.js';

export function resetGallery() {
    refs.movieGallery.innerHTML = "";
}

